import styled from "styled-components";
import { theme } from "../../theme";

export const StyledQRContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  width: 100%;
  div.qr-actions {
    display: flex;
    width: 90%;
    justify-content: center;
    align-items: center;
    button {
      width: 100%;
      margin-top: 24px;
      &:first-child {
        margin-right: 16px;
        @media (max-width: 768px) {
          margin-right: 0;
        }
      }
    }
    @media (max-width: 768px) {
      display: flex;
      justify-content: center !important;
      align-items: center;
      flex-direction: column;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

export const StyledUpdateQrContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: fit-content;
  min-width: 80%;
  margin: 0 auto;
  border: 2px solid ${theme.textColor.primaryGray};
  padding: 24px 0 24px 24px;
  @media (max-width: 990px) {
    width: 90%;
    padding: 16px;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
`;
